import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202512: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202512",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2025-12-01",
    endDate: "2025-12-31",
    impressions: 3284,
    clicks: 53,
    adsSpendDollars: 236,
    budgetDollars: 500,
    salesDollars: 1824,
    bestEstimateRoas: 7.73,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.47,
    reorderConversions: 8,
    dataAvailableAtDate: "2026-01-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
